/**
 * Use Notification Hook
 *
 * Custom hook for accessing notification context.
 *
 * @since 1.0.0
 */

import { useContext } from "react";

import { NotificationContext } from "./context";
import type { NotificationContextValue } from "./types";

/**
 * Use notification hook
 *
 * @since 1.0.0
 *
 * @return Notification context value.
 */
export const useNotification = (): NotificationContextValue => {
  const context = useContext(NotificationContext);

  if (context === undefined) {
    throw new Error(
      "useNotification must be used within a NotificationProvider",
    );
  }

  return context;
};
